import axios from '@/axios';

export async function getUsers(params) {
    const { data } = await axios.get("/users/filter", { params });
    return data;
}

export async function saveUser(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/users/${id}` : `/users`;
    return await axios({ method, url, data: data });
}

export async function getProfilesList() {
    const { data } = await axios.get("/profiles");
    return data.data ? data.data : data;
}

export async function getSex() {
    const { data } = await axios.get("/sex");
    return data.data ? data.data : data;
}

export async function getUserUnities() {
    const { data } = await axios.get("/unities");
    return data.data ? data.data : data;
}
